// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Centralized query key definitions for exchange order-related queries.
 * All exchange order query keys should be defined here to ensure consistency.
 */

/**
 * Base query key for all exchange order queries.
 * Invalidating this key will invalidate all exchange order-related queries.
 */
export const exchangeOrdersQueryKey = ['exchangeOrders'] as const;

/**
 * Creates a query key for an exchange order list with optional filters.
 *
 * @param filter - Optional filter parameters
 * @returns Query key array for the exchange order list query
 */
export function exchangeOrderListQueryKey(filter?: unknown) {
  return filter ? [...exchangeOrdersQueryKey, filter] : exchangeOrdersQueryKey;
}
